import * as React from 'react';
import { FormattedMessage } from "react-intl";
import Tags from '../tags/tags';
import './card.scss';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(faArrowRight);

class Card extends React.Component {
    render() {
        
        let smallCard = this.props.smallCard ? true : false;
        let extraSmallCard = this.props.extraSmallCard ? true : false;
        let videoClass = this.props.cardData.articleVideoId ? "is-video" : "is-image";
        let videoId = this.props.cardData.articleVideoId ? this.props.cardData.articleVideoId : null;
        let renderImage = false;
        let renderImages = this.props.renderImage ? true : false;
        let baseUrl = this.props.baseUrl ? this.props.baseUrl : ".";

        if(this.props.hideImageOnMobile) {
            videoClass = videoClass + " d-none d-sm-block";
        }

        if(this.props.cardData.articleThumbnail || videoId) {
            if(renderImages !== false && this.props.cardData.articleThumbnail) {
                renderImage = true;
            }
        }
        
        if (extraSmallCard) {
            return ( 
                <div className="card extra-sm-card mb-4">
                    <a className='card-link' onClick={() => {this.props.changeRoute(this.props.issueId, this.props.cardData.articleId)}} href={'./index.html?issueid='+this.props.issueId+'&articleid='+this.props.cardData.articleId+"&lang="+this.props.locale}>
                        <div className="card-body">
                            <h5 className="card-title">{this.props.cardData.articleTitle}</h5>
                        </div>
                    </a>
                </div>   
            )
        } else if (smallCard) {
            return ( 
                <div className="card sm-card mb-4">
                    <a className='card-link' onClick={() => {this.props.changeRoute(this.props.issueId, this.props.cardData.articleId)}} href={'./index.html?issueid='+this.props.issueId+'&articleid='+this.props.cardData.articleId+"&lang="+this.props.locale}>
                        {renderImage && <div className={videoClass}><img className="card-img-top" src={baseUrl+this.props.cardData.articleThumbnail} alt={this.props.cardData.articleThumbnailAlt}/></div>}
                        <div className="card-body">
                            <div className="card-tags">
                                <Tags tags={this.props.cardData.articleTags} readTime={this.props.cardData.articleReadTime} videoId={this.props.cardData.articleVideoId}/>
                            </div>
                            <h5 className="card-title">{this.props.cardData.articleTitle}</h5>
                        </div>
                    </a>
                </div>   
            )
        } else {
            return ( 
                <div className="card mb-3">
                    {renderImage && <div className={videoClass}><img className="card-img-top " src={baseUrl+this.props.cardData.articleThumbnail} alt={this.props.cardData.articleThumbnailAlt}></img></div>}
                    <div className="card-body">
                        <div className="card-tags">
                            <Tags tags={this.props.cardData.articleTags} readTime={this.props.cardData.articleReadTime} videoId={this.props.cardData.articleVideoId}/>
                        </div>
                        <h5 className="card-title">{this.props.cardData.articleTitle}</h5>
                        <p className="card-text">{this.props.cardData.articleSummary}</p>
                    </div>
                    <div className="card-footer text-muted">
                        <a className='btn btn-primary read-more' onClick={() => {this.props.changeRoute(this.props.issueId, this.props.cardData.articleId)}} href={'./index.html?issueid='+this.props.issueId+'&articleid='+this.props.cardData.articleId+"&lang="+this.props.locale}>
                            {this.props.cardData.articleMoreButtonText === "" ? (
                                <>{videoId ? (<FormattedMessage id="General.watchVideo" defaultMessage="Watch Video" />) : (<FormattedMessage id="General.readMore" defaultMessage="Read More" />)}</>
                                ) : (
                                <span>{this.props.cardData.articleMoreButtonText}</span>
                                )}
                            
                            <span className="more-arrow"><FontAwesomeIcon icon="arrow-right" /></span>
                        </a>
                    </div>
                </div>
            )
        }


    }
}

export default Card;
